
import React, { useState } from 'react';
import './ContactDialog.css';

export default function Contact() {
  const [form, setForm] = useState({ nom: '', prenom: '', mail: '', commentaire: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!form.mail || !form.commentaire) {
      setError('Mail et commentaire sont obligatoires.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) setSuccess('Message envoyé avec succès.');
      else setError(data.message || 'Erreur lors de l\'envoi.');
    } catch (e) {
      setError('Erreur lors de l\'envoi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-dialog">
      <h2>Contact</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Nom (optionnel)</label><br />
          <input name="nom" value={form.nom} onChange={handleChange} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Prénom (optionnel)</label><br />
          <input name="prenom" value={form.prenom} onChange={handleChange} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Mail <span style={{ color: 'var(--color-error, #c62828)' }}>*</span></label><br />
          <input name="mail" value={form.mail} onChange={handleChange} required type="email" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Commentaire <span style={{ color: 'var(--color-error, #c62828)' }}>*</span></label><br />
          <textarea name="commentaire" value={form.commentaire} onChange={handleChange} required style={{ minHeight: 80 }} />
        </div>
        {error && <div className="contact-error">{error}</div>}
        {success && <div className="contact-success">{success}</div>}
        <button type="submit" disabled={loading}>{loading ? 'Envoi...' : 'Envoyer'}</button>
      </form>
    </div>
  );
}
